<template>
    <div></div>
</template>

<script>
    export default {
        name: "vipCoachH5Down",
        created() {
            setTimeout(() => {
                location.href = 'https://apps.apple.com/cn/app/id1484591084'
            }, 1000)
        }
    }
</script>
